import angular from "angular";
import DashboardPageComponent from "./dashboard-page/dashboard-page";
import DateLinkComponent from "./date-link/date-link";
import QuoteCardComponent from "./quote-card/quote-card";
import CreateQuoteVersionModalComponent from "./create-quote-version-modal/create-quote-version-modal";

const DashboardModule = angular
  .module("modules.dashboard", [])
  .component("dashboardPage", DashboardPageComponent)
  .component("dateLink", DateLinkComponent)
  .component("quoteCard", QuoteCardComponent)
  .component("createQuoteVersionModal", CreateQuoteVersionModalComponent);

export default DashboardModule;
